<template lang="pug">
    #mental-wellness-workshop
      BLoading(:active="workshopLoading" :is-full-page="true")
      #wellness-container(v-if="!workshopLoading")
        .section.mb-0
          .companion-action-menu
            CompanionActionsMenu(:backButton="goBack")
          .show-topic-details
            .green-card(:style="{ backgroundColor: backgroundColor }")
              .registered-text(v-if="workshopRegState")
                WtSvgIcon(icon="companion/checkmark_white" width="20px" height="20px").mt-1
                span Registered
              .cover-art
                img(:src="workshop.HeroImage")
            .topic-details-card
              .topic-number-title {{ workshop.Title }}
              .topic-info-title
                span {{ workshop.Instructor }}
              .workshop-start-time
                  WtSvgIcon(icon="companion/calendar_black" width="16px" height="16px").mt-1
                  span {{ formatDate(workshop.StartDate) }}
              .chapters-info-title
                  WtSvgIcon( icon="icon_time" width="16px", height="16px" ).mt-1
                  span {{ workshop.Length }}
              .buttons-wrapper(v-if="!workshopRegState")
                button(v-if="isOngoing" @click="openDocumentInNewTab(workshop.JoiningUrl)" :class="{ 'blue-button': true }")
                  .text-button
                    span Join workshop
                button(v-if="isUpcoming" @click="openRegisterForWorkshopModal" :class="{ 'blue-button': true }")
                  .text-button
                    span Register now
                button(v-if="isUpcoming" @click="openDocumentInNewTab(workshop.WorksheetUrl)" :class="{ 'blue-button': true }" )
                  .icon-button
                    WtSvgIcon(icon="companion/article_white" width="16px" height="16px").mt-1
                    span View worksheet
                button(v-if="isCompleted" :class="{ 'grey-button': true }" )
                  .text-button
                    span This workshop has ended
                button(v-if="isCompleted" @click="openDocumentInNewTab(workshop.DocumentUrl)" :class="{ 'blue-button': true }" )
                  .icon-button
                    WtSvgIcon(icon="companion/article_white" width="16px" height="16px").mt-1
                    span View presentation
                button(v-if="isCompleted" @click="openDocumentInNewTab(workshop.VideoUrl)" :class="{ 'blue-button': true }" )
                  .icon-button
                    WtSvgIcon(icon="companion/plain_play_white" width="16px" height="16px").mt-1
                    span View video
              .joining-instructions(v-else)
                .top-section
                  WtSvgIcon(icon="companion/calendar" width="20px" height="20px").mt-1
                  span Joining instructions
                .middle-section
                  .joining-url-title(@click="openDocumentInNewTab(workshop.JoiningUrl)")
                    span( :style="{ color: '#2972F0' }" ) {{ workshop.JoiningUrlTitle }}
                  .joining-url-link(@click="copyToClipboard(workshop.JoiningUrl)")
                    WtSvgIcon(icon="companion/link" width="20px" height="20px").mt-1
                    span( :style="{ color: '#2972F0' }" ) Copy link
                .bottom-section(v-if="workshop.JoiningDetails")
                  .joining-details
                    span( :style="{ color: '#000000' }" ) {{ workshop.JoiningDetails }}
              .topic-part-summary(v-html="workshop.IntroText")
        .horizontal-divider(v-if="!workshopLoading")
        .section.companion-sub-content(v-if="!workshopLoading")
            WtTile.is-flex.is-flex-direction-column
                .column.is-12.custom-padding(v-if="havingRelatedTopics")
                    WtTitle.category-title Related topics
                    .topic-card-container
                        CompanionTopicCard.topic-card(
                          v-for="(topic, index) in workshop.RelatedTopics"
                          :key="index" :previewImage="topic.PreviewImage"
                          :id="topic.Id" :partTitle="topic.Title"
                          :numberOfGuides="topic.NumberOfGuides"
                          :redirectTo="`/plan/topic/${topic.Id}`")
                .related-guides(v-if="havingRelatedGuides")
                    WtTitle.category-title Related guides
                    .guide-card-container
                        CompanionGuideCard.guide-card(
                          v-for="(guide, index) in workshop.RelatedGuides"
                          :key="index" :partNumber="guide.Number"
                          :previewImage="guide.PreviewImage"
                          :id="guide.GuideId"
                          :duration="guide.Duration"
                          :partTitle="guide.GuidePartTitle"
                          :partId="guide.GuidePartId"
                          :redirectTo="`/plan/guide/${guide.GuidePartId}`" )
                .column.is-12.pl-0.pr-0.pt-0.pb-0(v-if="workshopRegState")
                  .button-container
                    WtButton.is-fullwidth.modal-exit-button.mb-1( size="medium" @click.native="openCancelBookingModal") Cancel booking
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import { mapActions, mapGetters } from "vuex";
import CompanionTopicCard from "@@/Companion/CompanionTopicCard";
import CompanionGuideCard from "@@/Companion/CompanionGuideCard";
import CompanionRightArrowCard from "@@/Companion/CompanionRightArrowCard";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import CompanionContentCard from "@@/Companion/CompanionContentCard";
import CompanionRatingCard from "@@/Companion/CompanionRatingCard";
import CompanionWorkshopRegisterUnregisterModal from "@@/Companion/CompanionWorkshopRegisterUnregisterModal";
import { formatDate } from "@/utils/dateFormatter";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";

export default {
  name: "CompanionWorkshop",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon,
    CompanionTopicCard,
    CompanionGuideCard,
    CompanionRightArrowCard,
    CompanionActionsMenu,
    CompanionContentCard,
    CompanionRatingCard
  },
  mixins: [analyticsTrackingMixin],
  data() {
    return {
      workshop: {},
      workshopRegState: false,
      workshopLoading: true,
      backgroundColor: "#ffffff"
    };
  },
  computed: {
    ...mapGetters("companion", ["getWorkshopById", "getWorkshopRegStateById"]),
    ...mapGetters("program", ["isCoreTier"]),

    havingRelatedGuides() {
      return (
        this.workshop?.RelatedGuides && this.workshop.RelatedGuides.length > 0
      );
    },

    havingRelatedTopics() {
      return (
        this.workshop?.RelatedTopics && this.workshop.RelatedTopics.length > 0
      );
    },

    formattedStartDate() {
      return this.workshop.StartDate
        ? this.formatDate(this.workshop.StartDate)
        : "";
    },

    isUpcoming() {
      const now = new Date();
      return this.workshop.StartDate && new Date(this.workshop.StartDate) > now;
    },
    isOngoing() {
      const now = new Date();
      return (
        this.workshop.StartDate &&
        this.workshop.EndDate &&
        new Date(this.workshop.StartDate) <= now &&
        new Date(this.workshop.EndDate) >= now
      );
    },
    isCompleted() {
      const now = new Date();
      return this.workshop.EndDate && new Date(this.workshop.EndDate) < now;
    }
  },
  async mounted() {
    this.trackFeatureView("learn", "learn_workshop");
    if (this.isCoreTier) {
      this.$router.push({ name: "404" });
    }
    try {
      const workshopId = this.$route.params.workshopId;

      let response = this.getWorkshopById(workshopId);
      let userWorkshopRegState = this.getWorkshopRegStateById(workshopId);

      if (
        Object.keys(response).length === 0 ||
        Object.keys(response.data).length === 0
      ) {
        response = await this.fetchWorkshop({
          workshopId: workshopId
        });
      }
      if (userWorkshopRegState === null) {
        userWorkshopRegState = response.data.IsUserRegistered;
      }
      this.workshopLoading = false;
      this.workshop = response.data;
      this.backgroundColor = "#" + this.workshop.BackgroundColor;
      this.workshopRegState = userWorkshopRegState;
    } catch (e) {
      this.workshopLoading = false;
      this.snackBar({
        duration: 5000,
        type: "is-danger",
        message: e.message
      });
    }
  },
  methods: {
    ...mapActions("companion", [
      "fetchWorkshop",
      "registerOrUnregisterFromWorkshop"
    ]),
    formatDate,
    ...mapActions(["snackBar"]),
    goBack() {
      window.history.back();
    },
    openDocumentInNewTab(redirectUrl) {
      if (redirectUrl == null) {
        window.open("", "_blank");
      }
      window.open(redirectUrl, "_blank");
    },
    openCancelBookingModal() {
      const modalInstance = this.$buefy.modal.open({
        component: CompanionWorkshopRegisterUnregisterModal,
        props: {
          isRegistration: false
        },
        events: {
          close: () => modalInstance.close(),
          onConfirm: () => this.toggleWorkshopRegistration("unregister")
        }
      });
    },

    openRegisterForWorkshopModal() {
      const modalInstance = this.$buefy.modal.open({
        component: CompanionWorkshopRegisterUnregisterModal,
        props: {
          isRegistration: true
        },
        events: {
          close: () => modalInstance.close(),
          onConfirm: () => this.toggleWorkshopRegistration("register")
        }
      });
    },

    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.snackBar({
          duration: 5000,
          type: "is-success",
          message: "Link copied to clipboard."
        });
      } catch (err) {
        this.snackBar({
          duration: 5000,
          type: "is-danger",
          message: "Failed to copy the link."
        });
      }
    },

    async toggleWorkshopRegistration(registrationState) {
      try {
        const payload = {
          workshopId: this.workshop.Id,
          registrationState,
          memberEmail: this.$auth.user().email
        };
        const response = await this.registerOrUnregisterFromWorkshop(payload);

        if (response.success) {
          this.workshopRegState = registrationState === "register";
          this.snackBar({
            duration: 5000,
            type: "is-success",
            message:
              registrationState === "register"
                ? "Successfully registered for the workshop."
                : "Successfully unregistered from the workshop."
          });
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        this.snackBar({
          duration: 5000,
          type: "is-danger",
          message: "Failed to update workshop registration."
        });
      }
    }
  }
};
</script>

<style scoped>
#mental-wellness-workshop {
  min-height: 100%;
  margin: auto;
  max-width: 718px;
}

#wellness-container {
  max-width: 100%;
  min-height: 100%;
  border-radius: 12px !important;
  background-color: white;
}

.companion-action-menu {
  padding-bottom: 20px;
}

.section {
  padding: 24px 24px 24px 24px;
}

.horizontal-divider {
  height: 1px;
  margin: 0px !important;
}

.companion-sub-content {
  background-color: #fbfbfb;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 32px 24px 32px 24px;
}
.guide-card-container {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 8px !important;
}

.guide-card-container::-webkit-scrollbar {
  display: none;
}

.guide-card {
  width: 334px;
  height: 156px;
}

.topic-card-container {
  display: flex;
  scrollbar-width: none;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 8px !important;
}

.topic-card-container::-webkit-scrollbar {
  display: none;
}
.topic-card {
  margin: 0rem !important;
  width: 100% !important;
}

.category-title {
  font-family: Manrope;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #1b1d20;
  padding: 0px;
  margin-bottom: 1rem !important;
}
.title:not(:last-child) {
  margin-bottom: 0rem;
}
.custom-padding {
  padding: 0rem 0rem 1.5rem 0rem !important;
}

.button-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 8px !important;
  align-self: stretch !important;
  margin: 0px !important;
  padding-top: 28px;
}

.modal-exit-button {
  background-color: #ec493f !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 20px !important;
}

.show-topic-details {
  .green-card {
    min-height: 220px;
    border-radius: 16px;
    position: relative;

    .registered-text {
      background-color: #30a250;
      color: #fff;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      position: relative;
      line-height: 18px;
      padding: 8px 12px;
      border-radius: 8px;
      top: 18px;
      left: 18px;
      width: 126px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      position: absolute;
    }

    .cover-art {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .cover-art img {
      max-height: 220px;
      padding: 20px;
    }
  }

  .topic-details-card {
    padding: 28px 16px 0px 0px;

    .topic-title {
      color: #5a5c60;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.25px;
    }

    .topic-number-title {
      color: #1b1d20;
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: 0.18px;
      padding-top: 9px;
    }

    .topic-info-title {
      display: flex;
      gap: 4px;
      align-items: center;

      color: #5a5c60;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.25px;
      padding: 9px 0px 2px 0px;
    }

    .chapters-info-title {
      display: flex;
      gap: 4px;
      align-items: center;
      color: #5a5c60;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      padding: 9px 0px 24px 0px;
    }

    .workshop-start-time {
      display: flex;
      gap: 4px;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
    }

    .buttons-wrapper {
      display: flex;
      gap: 16px;
      align-items: center;
      flex-wrap: wrap;
      .blue-button {
        background-color: #2972f0;
        border-radius: 6px;
        border: none;
        color: white;
        &:hover {
          cursor: pointer;
        }
      }
      .grey-button {
        background-color: #f1f1f1;
        border-radius: 6px;
        border: none;
        color: #96989d;
      }
      .icon-button {
        display: flex !important;
        padding: 4px 8px;
        justify-content: center !important;
        align-items: center !important;
        gap: 8px !important;

        span {
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
        }
      }

      .text-button {
        display: flex !important;
        padding: 8px 8px;
        justify-content: center !important;
        align-items: center !important;
        gap: 8px !important;

        span {
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
        }
      }
    }

    .joining-instructions {
      display: flex;
      flex-direction: column;

      max-width: 286px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

      .top-section {
        background-color: #30a250;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border-radius: 8px;
        gap: 8px;

        color: #fff;
        text-align: center;
        font-family: Manrope;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
        padding: 6px 12px;
      }

      .middle-section {
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-size: 14px;
        font-weight: 600;
        padding: 0 4px;

        .joining-url-title,
        .joining-url-link {
          display: flex !important;
          padding: 4px 8px;
          justify-content: center !important;
          align-items: center !important;
          gap: 6px !important;

          span {
            color: #2972f0;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
          }

          &:hover {
            cursor: pointer;
          }
        }
      }

      .bottom-section {
        .joining-details {
          color: #5a5c60;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          display: flex;
          align-items: left;
          padding: 0px 12px 10px 12px;
        }
      }
    }

    .topic-part-summary {
      .avenir-medium {
        color: #1b1d20;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.25px;
        padding: 24px 0px 8px 0px;
      }

      p {
        color: #5a5c60;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.25px;
        padding-bottom: 20px;
      }

      ul {
        list-style-type: disc;
        padding-left: 24px;
      }

      li {
        color: #5a5c60;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.25px;
      }
    }
  }
}

@media (max-width: 768px) {
  #mental-wellness-workshop {
    max-width: 95%;
  }

  .guide-card-container {
    gap: 8px !important;
  }
  .guide-card {
    width: calc(50% - 0.75rem);
  }
  .category-title {
    width: 100%;
  }
  .topic-card-container {
    gap: 8px !important;
  }
  .topic-card {
    max-width: calc(50% - 0.75rem);
  }
}
@media (max-width: 480px) {
  #mental-wellness-workshop {
    max-width: 100%;
  }

  .guide-card-container {
    flex-wrap: wrap;
    gap: 16px !important;
  }
  .guide-card-container .guide-card {
    max-width: 100%;
  }
  .topic-card-container .topic-card {
    max-width: 100%;
  }
}
</style>
